import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryFavoritesHotelsWithOffersData = Offers.Endpoints.Favorites;

interface UseQueryFavoritesHotelsWithOffersOptions {
  enabled?: boolean;
  initialData?: UseQueryFavoritesHotelsWithOffersData;
}

interface UseQueryFavoritesHotelsWithOffersParameters {
  offerIds: string[];
}

const useQueryFavoritesHotelsWithOffers = (
  parameters: UseQueryFavoritesHotelsWithOffersParameters,
  options?: UseQueryFavoritesHotelsWithOffersOptions,
) => {
  const locale = getLocale();

  const query = useQuery<UseQueryFavoritesHotelsWithOffersData>(
    [QueryId.FAVORITES_HOTELS_WITH_OFFERS, parameters, locale],
    async () => {
      const fetchResponse = await fetch('/api/favorites/hotels-with-offers', {
        body: JSON.stringify({
          offerUniqueIds: parameters.offerIds,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'POST',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .then(response => response)
        .catch(error => {
          console.error('hooks.useQueryFavoritesHotelsWithOffers', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters.offerIds && options?.enabled,
      initialData: options?.initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryFavoritesHotelsWithOffers;
